import { render, staticRenderFns } from "./aftersale-list.vue?vue&type=template&id=242f5da8&scoped=true&"
import script from "./aftersale-list.vue?vue&type=script&lang=js&"
export * from "./aftersale-list.vue?vue&type=script&lang=js&"
import style0 from "./aftersale-list.vue?vue&type=style&index=0&id=242f5da8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f5da8",
  null
  
)

export default component.exports